import { State as RouteState } from 'config/routes';
import { call, put, select } from 'redux-saga/effects';
import { queryData } from 'store/sagas/apiService';
import { LoadType } from 'store/sagas/apiService/types';
import { resetDomainData } from 'store/state/domainData/actions';
import { prevRouteSelector } from 'store/state/selectors/router';

function* loadAgentConsoleHomeData() {
  const prevRoute: RouteState | null = yield select(prevRouteSelector);

  if (prevRoute) {
    yield put(resetDomainData({ loadType: LoadType.GetAgentOrOfficeSummary }));
  }

  yield call(queryData, {
    loadType: LoadType.GetAgentOrOfficeSummary,
    meta: {
      variables: {},
    },
  });
}

export function* agentConsoleHomePageHandler() {
  yield call(loadAgentConsoleHomeData);
}
